import { Flex, InlineNotification } from '@lego/klik-ui';
import { Loader } from '@/components/common/Loader';
import {
  type InstallerRow,
  osInstallerTableColumns,
} from '@/components/common/table/column_definitions/OsInstaller';
import { TableStoreProvider } from '@/components/common/table/store/Context';
import { Table } from '@/components/common/table/Table';
import { useDocumentTitle } from '@/hooks/common';
import { useOsInstallers } from '@/hooks/os';
import { useRegisterPageContext } from '@/providers/PageContextProvider';

export const OsInstallersPage = () => {
  useDocumentTitle('OS Downloads');

  const { data, isLoading } = useOsInstallers();

  useRegisterPageContext(data?.data);

  if (isLoading) {
    return <Loader />;
  }

  const installers: InstallerRow[] = data?.data.installers ?? [];

  return (
    <Flex direction="column" gap="4">
      <InlineNotification variant="info">
        <InlineNotification.Content>
          <InlineNotification.Description>
            These are default installers with standard network configuration. If your deployment
            requires a custom IP address, please reach out to the EMMA platform team.
          </InlineNotification.Description>
        </InlineNotification.Content>
      </InlineNotification>
      <InlineNotification variant="info">
        <InlineNotification.Content>
          <InlineNotification.Description>
            See the{' '}
            <a
              href="https://baseplate.legogroup.io/docs/default/component/emma/os_changelog/"
              rel="noopener noreferrer"
              style={{ color: '#3182ce', fontWeight: 'bold' }}
              target="_blank"
            >
              OS Changelog
            </a>{' '}
            for release notes.
          </InlineNotification.Description>
        </InlineNotification.Content>
      </InlineNotification>
      <TableStoreProvider initialSorting={[{ desc: true, id: 'version' }]} name="OsInstallers">
        <Table columns={osInstallerTableColumns} data={installers} title="OS Installers" />
      </TableStoreProvider>
    </Flex>
  );
};
